'use client';

import { createContext } from 'react';
import { useUniversalChat as useUniversalChatImpl } from './provider/ChatContext';
import type {
  UniversalChatContextPayload as UniversalChatContextPayloadType,
  UniversalChatContextValue as UniversalChatContextValueType,
} from './provider/types';

// Provide a legacy context so tests and helper hooks can inject custom chat state without reaching into the store directly.
export const UniversalChatContext = createContext<UniversalChatContextValueType | null>(null);

export function useUniversalChat() {
  return useUniversalChatImpl();
}

export type UniversalChatContextPayload = UniversalChatContextPayloadType;
export type UniversalChatContextValue = UniversalChatContextValueType;
